<template>
  <div id="app">
    <!-- 路由占位符，必不可少！ -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 建议加上全局样式，防止页面高度塌陷导致白屏 */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>